module.exports = __webpack_public_path__ + "img/qiti.09adc2f8.svg";